
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, LogIn } from 'lucide-react';
import { toast } from 'sonner';
import { useMobileMenu } from './MobileMenuContext';

interface MobileAuthSectionProps {
  user: any;
  signOut: () => Promise<void>;
}

const MobileAuthSection = ({ user, signOut }: MobileAuthSectionProps) => {
  const navigate = useNavigate();
  const { closeMenu } = useMobileMenu();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
      closeMenu();
    } catch (error) {
      toast.error('Error signing out');
    }
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    closeMenu();
  };

  return (
    <div className="p-6 border-t">
      {user ? (
        <button
          onClick={handleSignOut}
          className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-destructive/10 hover:text-destructive transition-colors"
        >
          <LogOut className="h-5 w-5" />
          <span className="font-medium">Log out</span>
        </button>
      ) : (
        <button
          onClick={() => handleNavigation('/auth')}
          className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-primary/10 hover:text-primary transition-colors"
        >
          <LogIn className="h-5 w-5" />
          <span className="font-medium">Sign In</span>
        </button>
      )}
    </div>
  );
};

export default MobileAuthSection;
